import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { ProfileUpdateApp } from './components/ProfileUpdate/ProfileUpdateApp'
import PrivacyPolicyPage from './components/Public/PrivacyPolicyPage'
import './index.css'

const pathname = window.location.pathname
const isProfileUpdate = pathname === '/profile-update'
const isPrivacyPolicy = pathname === '/privacy-policy'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {isPrivacyPolicy ? (
      <PrivacyPolicyPage />
    ) : isProfileUpdate ? (
      <ProfileUpdateApp />
    ) : (
      <App />
    )}
  </React.StrictMode>,
)




